import http from "../utils/http";
//
/**
 *  首页相关接口
 */

/** 获取首页1920*540大轮播 + banner上菜单栏*/
export function getIndexTop(params) {
  return http.get(`/index/banner`, params);
}

/** 获取首页秒杀数据*/
export function getIndexSeckill(params) {
  return http.get(`/index/goods_cache`, params);
}

/** 获取首页中间层数据*/
export function getIndexCenter(params) {
  return http.get(`/index/index`, params);
}

/** 获取首页品牌专区数据*/
export function getBrandList(params) {
  return http.get(`/index/ppzq`, params);
}

/** 获取首页每周特价数据*/
export function getWeeklyList(params) {
  return http.get(`/index/chosen`, params);
}

/** 获取首页弹框数据*/
export function getIndexBulletFrame(params) {
  return http.get(`/index/bulletframe`, params);
}

/** 新增--首页资质信息资料*/
export function getIndexQualifiesInfo(params) {
  return http.get(`/index/qualifies_info`, params);
}
/*超值钜惠*/
export function getIndexBargains(params) {
  return http.get(`/index/bargains`, params);
}
/*新增--首页超值拼团*/
export function getIndexScrabbleDough(params) {
  return http.get(`/index/goods_spell`, params);
}









// WEBPACK FOOTER //
// ./src/api/index.js